import { render, staticRenderFns } from "./Archiviate.vue?vue&type=template&id=67ffd8e2&"
import script from "./Archiviate.vue?vue&type=script&lang=js&"
export * from "./Archiviate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports